export default {"href":"/corgi/pageapps/purchase/_next/public/sprite-3.45.0-30c130124.svg#arrow-left","viewBox":"0 0 19 18"}